import { ToastType } from "../types/toast";

interface ToastOptions {
  autoHide?: boolean;
  duration?: number;
}

export function showToast(
  message: string,
  type: ToastType,
  options: ToastOptions = {}
) {
  const { autoHide = true, duration = 5000 } = options;
  const toastId = `kt_docs_toast_${Date.now()}`;

  let icon: string;
  if (type === "success") {
    icon = '<i class="fa-solid fa-circle-check"></i>';
  } else if (type === "error") {
    icon = '<i class="fa-solid fa-triangle-exclamation"></i>';
  } else {
    icon = '<i class="fa-solid fa-circle-info"></i>';
  }

  const toast = document.createElement("div");
  toast.className = "toast align-items-center text-white show";
  toast.id = toastId;
  toast.setAttribute("role", "alert");
  toast.setAttribute("aria-live", "assertive");
  toast.setAttribute("aria-atomic", "true");

  toast.innerHTML = `
    <div class="custom-toaster bg-${type}">
      <div class="icon-wrapper">
        ${icon}
      </div>
      <div class="toast-body">${message}</div>
      <button type="button" onClick="document.getElementById('${toastId}').remove()" class="btn-close btn-close-white ms-auto" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
  `;

  const container = document.getElementById("kt_docs_toast_stack_container");
  container?.appendChild(toast);

  if (autoHide) {
    setTimeout(() => {
      toast.remove();
    }, duration);
  }
}

export function clearToasts() {
  const container = document.getElementById("kt_docs_toast_stack_container");
  if (container) {
    container.innerHTML = "";
  }
}
